import { BASE_URL, AUTH_HEADERS } from "./config";

export const getCustomFieldsStatuses = async (leadId = null) => {
    const url = new URL(`${BASE_URL}/custom_fields_statuses`);
    if (leadId) {
        url.searchParams.append("lead_id", leadId)
    }
    const response = await fetch(url, {
        headers: AUTH_HEADERS
    });
    if (response.ok) {
        return await response.json();
    }
    return [];
};

export const getCustomFieldStatus = async (cfStatusId) => {
    const url = `${BASE_URL}/custom_fields_statuses/${cfStatusId}`;
    const response = await fetch(url, {
        headers: AUTH_HEADERS
    });
    if (response.ok) {
        return await response.json();
    }
    return {};
};

export const createCustomFieldStatus = async (customFieldStatus) => {
    const url = `${BASE_URL}/custom_fields_statuses`;
    const response = await fetch(url, {
        method: "POST",
        headers: AUTH_HEADERS,
        body: JSON.stringify(customFieldStatus)
    });
    if (response.ok) {
        return await response.json();
    }
    return {};
};

export const updateCustomFieldStatus = async (cfStatusId, customFieldStatus) => {
    const url = `${BASE_URL}/custom_fields_statuses/${cfStatusId}`;
    const response = await fetch(url, {
        method: "PATCH",
        headers: AUTH_HEADERS,
        body: JSON.stringify(customFieldStatus)
    });
    if (response.ok) {
        return await response.json();
    }
    return {};
};

export const deleteCustomFieldStatus = async (cfStatusId) => {
    const url = `${BASE_URL}/custom_fields_statuses/${cfStatusId}`;
    const response = await fetch(url, {
        method: "DELETE",
        headers: AUTH_HEADERS
    });
    if (response.ok) {
        return await response.json();
    }
};
